import axios from "axios"
import { ACCESS_TOKEN } from "./constants"
import { parseCookies } from "nookies"

const axiosFinancialServices = axios.create({
  baseURL: process.env.REACT_APP_FINANCIAL_BASE_URL || "http://please-add-server-url.please",
  timeout: 100000,
  headers: { "Content-Type": "application/json" },
})

// ==============================|| AXIOS - FOR MOCK SERVICES ||============================== //

axiosFinancialServices.interceptors.request.use(
  async (config) => {
    const accessToken = parseCookies()[ACCESS_TOKEN]
    if (accessToken) {
      config.headers["Authorization"] = `Bearer ${accessToken}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

axiosFinancialServices.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401 && !window.location.href.includes("/login")) {
      window.location.pathname = "/maintenance/500"
    }
    return Promise.reject((error?.response && error?.response?.data) || "Network Error")
  },
)

export default axiosFinancialServices
